import {IntegrationSpecs} from "./IntegrationSpecs";
import {SubscriptionSpecs} from "./SubscriptionSpecs";
import {PermissionSpecs} from "./PermissionSpecs";
import {getAppRouteData} from "../../helper/utils/getAppRouteData";
import {getRouteDefaultRequiredLevel} from "../../helper/utils/getRouteDefaultRequiredLevel";
import {PermissionResult} from "../../helper/permission/PermissionResult";
import {PermissionKeysByType} from "../../helper/permission/enum/PermissionKeysByType";
import {SubscriptionScopeKeysByType} from "../../helper/subscription/enum/SubscriptionScopeKeysByType";
import { MiscellaneousSpecs } from "./MiscellaneousSpecs";

export class AccessSpecs {
    constructor() {
        this.permission = new PermissionSpecs();
        this.subscription = new SubscriptionSpecs();
        this.integration = new IntegrationSpecs();
        this.miscellaneous = new MiscellaneousSpecs();
    }

    getFromUrl(url) {
        // Getting a match
        const route = getAppRouteData(url);

        // PermissionSpecs
        this.permission.keys = route?.permission || [];
        this.permission.requiredLevel = getRouteDefaultRequiredLevel(route);
        this.permission.inhibitorModifiers = route?.inhibitorModifiers || [];
        this.permission.checkMethod = Array.isArray(route?.permission) ? route?.permissionCheckMethod || 'AND' : undefined;

        // SubscriptionSpecs
        this.subscription.keys = route?.subscription || [];
        this.subscription.checkMethod = Array.isArray(route?.subscription) ? route?.subscriptionCheckMethod || 'AND' : undefined;

        // IntegrationSpecs
        this.integration.keys = route?.integration || [];

        // MiscellaneousSpecs
        this.miscellaneous.allowedCountryCodes = route?.allowedCountryCodes || [];
        this.miscellaneous.settingsRequired = route?.settingsRequired || [];
        this.miscellaneous.appsRequired = route?.appsRequired || [];

        return this;
    }

    getFromCurrentRoute() {
        if (!window || !window.location.pathname)
            return new PermissionResult();

        // Getting a match
        const url = window.location.pathname;
        return this.getFromUrl(url);
    }

    getFromTransactionType(type) {
        // PermissionSpecs
        this.permission.keys = PermissionKeysByType[type] || [];

        // SubscriptionSpecs
        this.subscription.keys = SubscriptionScopeKeysByType[type] || [];

        return this;
    }

    setKeys({ permission, subscription, integration }) {
        if (permission)
            this.permission.keys = permission;
        if (subscription)
            this.subscription.keys = subscription;
        if (integration)
            this.permission.keys = integration;
        return this;
    }
}
